// M16 T15/T21 — AI kontrolü + form ↔ KPI tutarlılığı API sarmalayıcıları (/api/v1/kpi/*).
import type { KpiAiCheckResult, KpiFormMismatch } from "@mahir/shared";
import { api } from "./client";

export interface KpiAiCheckRecord extends KpiAiCheckResult {
  id: string;
  setId: string;
}

export async function runKpiAiCheck(setId: string, years?: number[]): Promise<KpiAiCheckRecord> {
  const r = await api<{ check: KpiAiCheckRecord }>(`/kpi/sets/${setId}/ai-check`, {
    method: "POST",
    body: years ? { years } : {},
  });
  return r.check;
}

export async function getLatestKpiAiCheck(setId: string): Promise<KpiAiCheckRecord | null> {
  const r = await api<{ check: KpiAiCheckRecord | null }>(`/kpi/sets/${setId}/ai-check/latest`);
  return r.check;
}

export async function listKpiSetFormMismatches(setId: string): Promise<KpiFormMismatch[]> {
  const r = await api<{ mismatches: KpiFormMismatch[] }>(`/kpi/sets/${setId}/form-consistency`);
  return r.mismatches;
}

export async function getProjectKpiConsistency(
  projectId: string,
): Promise<{ hasKpiSet: boolean; mismatches: KpiFormMismatch[] }> {
  return api(`/kpi/projects/${projectId}/kpi-consistency`);
}

/** Form yanıtını KPI hücresine yazar (varsayılan işletme, proje yılı). */
export async function applyFormToKpi(
  projectId: string,
  questionCode: string,
): Promise<KpiFormMismatch | null> {
  const r = await api<{ applied: KpiFormMismatch | null }>("/kpi/values/from-form", {
    method: "POST",
    body: { projectId, questionCode },
  });
  return r.applied;
}

/** KPI hücresini form yanıtına yazar. */
export async function applyKpiToForm(
  projectId: string,
  questionCode: string,
): Promise<KpiFormMismatch | null> {
  const r = await api<{ applied: KpiFormMismatch | null }>(
    `/kpi/projects/${projectId}/responses/from-kpi`,
    { method: "POST", body: { questionCode } },
  );
  return r.applied;
}
